import styled, {css} from 'styled-components';

import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis, flexCenter} from '../../../../libs/shared/ui/src/styles/mixins';

export const StyledTabBaseElement = styled(ChromelessButton)<{
  $isSelected?: boolean;
  $isDisabled?: boolean;
  $hideBorders?: boolean;
  $noMarginRight?: boolean;
}>`
  ${flexCenter};

  height: 31px;
  padding: 7px 12px 6px 12px;
  margin-right: ${(p) => (p.$noMarginRight ? 0 : '8px')};
  margin-bottom: -1px;
  background-color: ${(p) => p.theme.greys.white};
  color: ${(p) => (p.$isDisabled ? p.theme.greys.shade50 : p.theme.greys.shade90)};
  min-width: 0; /* Making sure tabs can shrink on smaller screens. */

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()}

  ${(p) => computeSelectedStyles(p.$isSelected, p.$isDisabled, p.$hideBorders)}

  /* Don't shrink All Data tab */
  &:first-child {
    min-width: auto;
    overflow: visible;
  }
`;

const computeSelectedStyles = (isSelected?: boolean, isDisabled?: boolean, hideBorders?: boolean) => {
  // Tab without borders
  if (hideBorders) {
    return css`
      border-radius: 100px; /* This border radius is needed for the background in the onHover state */
      position: relative; /* The position relative is needed for positioning our bottom border */
      &:hover {
        text-shadow: 0px 0px 1px ${(p) => p.theme.greys.shade60}; /* Using text-shadow to avoid changing the tab width on hover with a bolder font */
        color: ${(p) => p.theme.greys.shade90};
        background-color: ${(p) => p.theme.greys.shade20};
        border-bottom-color: transparent;
      }
      // This 'before' attribute defines the bottom border - it is seperate from the actual div because we don't want it
      // to use the border radius of the hovering state
      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        height: 1px;
        width: 100%;
        border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
      }
    `;
  }

  // Unselected tab with border and hover effect.
  if (!isSelected) {
    return css`
      color: ${(p) => (isDisabled ? p.theme.greys.shade40 : p.theme.greys.shade70)};
      border: 1px solid ${(p) => p.theme.greys.shade30};

      ${!isDisabled &&
      css`
        &:hover {
          text-shadow: 0px 0px 1px ${(p) => p.theme.greys.shade60}; /* Using text-shadow to avoid changing the tab width on hover with a bolder font */
          color: ${(p) => p.theme.greys.shade90};
          background-color: ${(p) => p.theme.greys.shade20};
          border-bottom-color: transparent;
        }
      `}
    `;
  }

  // Selected tab with border and no hover effect.
  return css`
    border: 1px solid ${(p) => p.theme.greys.shade30};
    border-bottom-color: transparent;
  `;
};

export const StyledTabElementsWrapper = styled.div`
  display: flex;
`;
